<template>
<div>
  <vx-card>
    <div class="">      
        <vs-row vs-w="12">
            <vs-radio class="mr-6" v-model="showID" vs-value="callerID"><span>Single Caller ID</span></vs-radio>
            <vs-radio v-model="showID"  vs-value="rotateingCallerID"><span>Rotating Caller ID</span></vs-radio>
        </vs-row>
        <vs-row vs-w="12" class="mt-6 flex justify-start items-center" v-if="showID === 'callerID'">
            <span class="ml-1">Caller ID</span>
            <v-select
              style="min-width: 200px"
              class="ml-6 mr-3"
              name="company"
            />
        </vs-row>
        <vs-row vs-w="12" class="mt-6 flex justify-start items-center" v-else>
            <span class="ml-1">Caller ID Group</span>
            <v-select
              style="min-width: 200px"
              class="ml-6 mr-3"
              name="company"
            />
        </vs-row>
         <vs-row vs-w="12" class="mt-6">
            <vs-radio class="mr-6" vs-value="singleContact" v-model="show"><span>Single Contact</span></vs-radio>
            <vs-radio class="mr-6" vs-value="bulkSMS" v-model="show"><span>Bulk SMS</span></vs-radio>
            <vs-radio class="mr-6" vs-value="contactGroup" v-model="show"><span>Contact Group</span></vs-radio>
            <vs-radio class="mr-6" vs-value="dynamicContent" v-model="show"><span>Dynamic Content</span></vs-radio>

        </vs-row>
        <vs-row vs-w="12" class="mt-6 flex-column" v-if="show === 'singleContact' && showID === 'rotateingCallerID'">
            <div class="ml-1 flex justify-start items-center mb-6">
                <span class="mr-6">Destination Number</span>
                <vs-input
                    class="mt-2"
                />
            </div>
            <div class="smsc-box__item flex">
                <span class="mr-6">Message</span>
                <vs-textarea
                    class="w-25"
                    height="160px"
                />
          </div>
        </vs-row>
        <vs-row vs-w="12" class="mt-6 flex-column" v-if="show === 'bulkSMS' && showID === 'rotateingCallerID'">
            <div class="flex">
                <vs-radio class="mr-6" vs-name="radios1" vs-value="paste" v-model="showImport"><span>Paste</span></vs-radio>
                <vs-radio class="mr-6" vs-name="radios1" vs-value="import" v-model="showImport"><span>import</span></vs-radio>
                <vs-checkbox class="mr-6" v-model="payload.add_random_text"><span>Enable Random text</span></vs-checkbox>
            </div>    
            <div class="ml-1 mt-6 flex justify-start items-center mb-6" v-if="showImport === 'import'">
                <span class="mr-6">Upload Contact</span>
                <div class="mb-3">
                    <input class="form-control" type="file" id="formFile">
                </div>
            </div>            
            <div class="ml-1 flex justify-start items-center mb-6">
                <span class="mr-6">Destination Number</span>
                <div class="w-100">
                    <vs-input
                        class="mt-2"
                        v-validate="'required'"
                        :class="{'is-danger': errors.has('destinations')}"
                        type="text"
                        name="destinations"
                        placeholder="Enter destiantion numbers"
                        v-model="payload.destinations"
                    />
                    <span class="text-danger text-xs">{{ errors.first('destinations') }}</span>
                </div>
            </div>
            <div class="smsc-box__item flex">
                <span class="mr-6">Message</span>
                <div class="w-100">    
                    <vs-textarea
                        class="w-25"
                        height="160px"
                        v-validate="'required'"
                        :class="{'is-danger': errors.has('text')}"
                        type="text"
                        name="text"
                        placeholder="Enter message"
                        v-model="payload.text"   
                    />
                    <span class="text-danger text-sm">{{ errors.first('text') }}</span>
                </div>    
          </div>
        </vs-row>
        <vs-row vs-w="12" class="mt-6 flex-column" v-if="show === 'contactGroup' && showID === 'rotateingCallerID'">
            <div class="ml-1 flex justify-start items-center mb-6">
                <span class="mr-6">Contact Group</span>
                <vs-input
                    class="mt-2"
                />
            </div>
            <div class="smsc-box__item flex">
                <span class="mr-6">Message</span>
                <vs-textarea
                    class="w-25"
                    height="160px"
                />
          </div>
        </vs-row>
        <vs-row vs-w="12" class="mt-6 flex-column" v-if="show === 'dynamicContent' && showID === 'rotateingCallerID'">
            <div class="ml-1 flex justify-start items-center mb-6">
                <span class="mr-6">Upload Contact and Message </span>
                <div class="mb-3">
                    <input class="form-control" type="file" id="formFile">
                </div>
            </div>    
        </vs-row>
    </div>    
    <div class="flex justify-center items-center mt-6">
      <vs-button class="mb-6" @click="Add()">Submit</vs-button>
    </div>  
    </vx-card>
</div>
</template>

<script>
import TableMixin from '@/mixins/table.js'

// Packages
import { AgGridVue } from 'ag-grid-vue';
// import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/views/admin/dashboard/StatisticsCardLine.vue'
import analyticsData from '@/views/admin/dashboard/analyticsData.js'
import ChangeTimeDurationDropdown from '@/views/admin/dashboard/ChangeTimeDurationDropdown.vue'
import VsInputPhone from '../../../../components/VsInputPhone.vue';
import vSelect from 'vue-select'
import VxInputGroup from '../../../../components/vx-input-group/VxInputGroup.vue';
export default {
         mixins: [TableMixin],
  components: {
    vSelect,
    AgGridVue,
    VueApexCharts,
    StatisticsCardLine,
    VuePerfectScrollbar,
    ChangeTimeDurationDropdown,
    VsInputPhone,
    VxInputGroup,
    // CellRendererActions
  },
  data () {
    return {      
      radios1:'primery',
    //   showFirst: false,
      show: 'singleContact',
      showID: 'callerID',
      showImport: 'paste',
      randomText: false,
      payload: {
          destinations: "",
          text: "",
          add_random_text: false,
      }
    }
  },
  methods:{
     async Add() {
      const valid = await this.$validator.validate()
      
      if (!valid) {
        return
      }

      let data = {
        destinations: this.payload.destinations.split(' '),
        text: this.payload.text,
        add_random_text: this.payload.add_random_text,
      }

      this.$vs.loading()
      this.$store.dispatch('bulk/Add', data)
      .then(res => {
        this.$router.push({ name: 'company-admin-campaign-bulk-list' }).catch(()=>{})
        this.ShowSuccessMessage({ title: 'Success', text: 'Ok' })
        window.location.reload()
      })
      .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
      .finally(() => this.$vs.loading.close())
    },  
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    },
  }
}
</script>
